import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import CourseDetailsMain from "./CourseDetailsMain";

const CourseDetails = () => (
  <>
    <Header />
    <CourseDetailsMain />
    <Footer />
  </>
);

export default CourseDetails;
